import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { angularjs } from './migration-helpers/angularjs.injection';
import type { ILoggerService } from './logger.service';

@Injectable()
export class GlobalAngularErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);
  private readonly upgradeModule = inject(UpgradeModule);
  private loggerService: ILoggerService | null = null;

  private getLoggerService(): ILoggerService | null {
    if (this.loggerService) {
      return this.loggerService;
    }

    if (!this.upgradeModule.$injector) {
      return null;
    }

    this.loggerService = this.injector.get<ILoggerService>(angularjs.loggerService);
    return this.loggerService;
  }

  handleError(error: unknown): void {
    const exception = error instanceof Error ? (error.stack ?? error.message) : String(error);
    const loggerService = this.getLoggerService();

    if (loggerService) {
      loggerService.error('Unhandled Angular Error', { exception });
      return;
    }

    console.error('Unhandled Angular Error', { exception });
  }
}
